import {
  easeInOutSine,
  smoothstep,
  clamp,
  w, h,
  frame,
  frameN,
  setFrameN,
  getCanvasSize,
  setupCommon,
  drawCommon,
  make,
} from '../js/common.js';

export function setup() {
	setupCommon();
}

export function draw() {
	drawCommon();
	background(12);

	const r = 0.1 + Math.sin(frameN * TAU) * 0.05;
	const d = 0.01 + Math.sin(frameN * TAU + PI) * 0.05;
	const g = d * 2;
	const n = 15;
	const dt = HALF_PI / (n - 1);
	const w0 = 2 * r + d;
	const off = w0 / 2;

	rotate(PI * frameN);
	fill(0, 40, 70);
	stroke(0, 40, 70);
	for (let yoff = 0.5 - 15 * w0; yoff < 1 + 4 * w0; yoff += w0 + g) {
		for (let xoff = 0.5 - 15 * w0; xoff < 1 + 4 * w0; xoff += w0 + g) {
			beginShape();
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t) * r + xoff - off;
				const y = Math.sin(t) * r + yoff - off;
				vertex(w(x), h(y));
			});
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t - HALF_PI) * r + xoff - off;
				const y = Math.sin(t - HALF_PI) * r + yoff + off;
				vertex(w(x), h(y));
			});
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t - PI) * r + xoff + off;
				const y = Math.sin(t - PI) * r + yoff + off;
				vertex(w(x), h(y));
			});
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t + HALF_PI) * r + xoff + off;
				const y = Math.sin(t + HALF_PI) * r + yoff - off;
				vertex(w(x), h(y));
			});
			endShape(CLOSE);
		}
	}

	fill(290, 20, 60);
	stroke(290, 20, 60);
	for (let yoff = 0.5 - 15 * w0 - off - (g / 2); yoff < 1 + 4 * w0; yoff += w0 + g) {
		for (let xoff = 0.5 - 15 * w0 - off - (g / 2); xoff < 1 + 4 * w0; xoff += w0 + g) {
			beginShape();
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t) * r + xoff - off;
				const y = Math.sin(t) * r + yoff - off;
				vertex(w(x), h(y));
			});
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t - HALF_PI) * r + xoff - off;
				const y = Math.sin(t - HALF_PI) * r + yoff + off;
				vertex(w(x), h(y));
			});
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t - PI) * r + xoff + off;
				const y = Math.sin(t - PI) * r + yoff + off;
				vertex(w(x), h(y));
			});
			[...Array(n).keys()].forEach(i => {
				const t = i * dt;
				const x = Math.cos(t + HALF_PI) * r + xoff + off;
				const y = Math.sin(t + HALF_PI) * r + yoff - off;
				vertex(w(x), h(y));
			});
			endShape(CLOSE);
		}
	}

	noStroke();

	fill(290, 20, 60);
	for (let yoff = 0.5 - 15 * w0; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}
	for (let yoff = 0.5 - 15 * w0 + w0 + g; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0 + w0 + g; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}


	fill(0, 40, 70);
	for (let yoff = 0.5 - 15 * w0 - off - (g / 2); yoff < 1 + 3 * w0; yoff += w0 + g) {
		for (let xoff = 0.5 - 15 * w0 - off - (g / 2); xoff < 1 + 3 * w0; xoff += w0 + g) {
			const x = xoff - g / 2;
			const y = yoff + r + d;
			rect(w(x), h(y), w(g), h(d));
		}
	}

	fill(290, 20, 60);
	for (let yoff = 0.5 - 15 * w0; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0 + w0 + g; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}
	for (let yoff = 0.5 - 15 * w0 + w0 + g; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}

	fill(0, 40, 70);
	for (let yoff = 0.5 - 15 * w0 + (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0 - (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}
	for (let yoff = 0.5 - 15 * w0 - (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0 + (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}

	fill(290, 20, 60);
	for (let yoff = 0.5 - 15 * w0 - w0 - g; yoff < 1 + 3 * w0; yoff += w0 + g) {
		for (let xoff = 0.5 - 15 * w0 - w0 - g; xoff < 1 + 3 * w0; xoff += w0 + g) {
			const x = xoff - g / 2;
			const y = yoff + r + d;
			rect(w(x), h(y), w(g), h(d));
		}
	}

	fill(0, 40, 70);
	for (let yoff = 0.5 - 15 * w0 + (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0 + (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}
	for (let yoff = 0.5 - 15 * w0 - (w0 + g) / 2; yoff < 1 + 3 * w0; yoff += 2 * (w0 + g)) {
		for (let xoff = 0.5 - 15 * w0 - (w0 + g) / 2; xoff < 1 + 3 * w0; xoff += 2 * (w0 + g)) {
			const x = xoff + r + d;
			const y = yoff - g / 2;
			rect(w(x), h(y), w(d), h(g));
		}
	}
}
